/**
 * Missões history viewer — RJ-9 placeholder.
 *
 * Phase 2 only ships the entry-point rows. The real per-period viewer
 * (day grid + AI summary card) lands in RJ-9. This screen exists today
 * so MissionHistoryRow taps land somewhere predictable instead of a
 * not-found state.
 */

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { useLanguage } from '@/contexts/LanguageContext';

export default function MissoesHistoryScreen() {
  const router = useRouter();
  const { t } = useLanguage();
  const { period } = useLocalSearchParams<{
    period?: 'day' | 'week' | 'month' | 'quarter' | 'halfyear' | 'year';
  }>();

  const periodLabelKey: Record<string, string> = {
    day: 'missoes.history.yesterday',
    week: 'missoes.history.week',
    month: 'missoes.history.month',
    quarter: 'missoes.history.threeMonths',
    halfyear: 'missoes.history.sixMonths',
    year: 'missoes.history.twelveMonths',
  };
  const headerLabel = period ? t(periodLabelKey[period] || 'missoes.history.heading') : t('missoes.history.heading');

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => router.back()} style={styles.backButton} activeOpacity={0.7}>
          <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <Path
              d="M15 6l-6 6 6 6"
              stroke="#151515"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </Svg>
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{headerLabel}</Text>
        <View style={{ width: 40 }} />
      </View>

      <View style={styles.body}>
        <Text style={styles.placeholderTitle}>Em breve</Text>
        <Text style={styles.placeholderBody}>
          O histórico detalhado das suas missões chega na próxima atualização.
        </Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9F8F3',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#151515',
  },
  body: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  placeholderTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#151515',
    marginBottom: 8,
  },
  placeholderBody: {
    fontSize: 14,
    color: '#7E7D75',
    textAlign: 'center',
    lineHeight: 20,
  },
});
